module.exports = __webpack_public_path__ + "img/header_dsk.fa4c7cd.webp";